module.exports = __webpack_public_path__ + "img/egg.1b052beb.gif";